<template>
  <div class="steps">
    <div v-if="stepsList.length === 0 && loadEnd" class="noContent">
      <img src="../../assets/images/blank_icon_project.png">
      <div class="blank-tip">暂无进度</div>
    </div>
    <div v-else class="van-steps van-steps--vertical">
      <div class="van-steps__items">
        <div v-for="item in stepsList" class="van-hairline van-step van-step--vertical van-step--process">
          <div class="van-step__title">
            <div class="title">{{ item.operate }}</div>
            <p class="time">{{ item.createTime }}</p>
          </div>
          <div class="van-step__circle-container"><i
            class="van-icon van-icon-checked van-step__icon van-step__icon--active"><!----></i></div>
          <div class="van-step__line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectProgress } from '@api/project'

export default {
  name: 'steps',
  components: {},
  data () {
    return {
      loadEnd: false,
      stepsList: [],
    }
  },
  created () {
    this.id = this.$route.query.projectId
    // 获取项目进度
    this.getProjectProgress()
  },
  methods: {
    getProjectProgress () {
      getProjectProgress({ id: this.id }).then(res => {
        if (res.data.code === 200) {
          this.loadEnd = true
          this.stepsList = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

.van-step__title{
  margin-top: -5px;
}

.steps {
  margin-top: 15px;

  .van-step {
    padding: 10px 5px 15px 0;

    .van-step__title {
      line-height: initial;
      .title {
        color: #333333FF;
        @include add_size($font_size_18);
      }

      .time {
        @include add_size($font_size_14);
        padding: 15px 0 0 0;
      }
    }

    .van-step__icon--active {
      color: #096CEFFF;
      @include add_size($font_size_16);
    }

    .van-step__line {
      background-color: #096CEFFF;
    }
  }
}
</style>
